import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Kartable_Controller_Review_Interface } from 'src/app/Interface/Kartable_Controller_Review_Interface';
import { Kartable_Customer_Device_Interface } from 'src/app/Interface/Kartable_Customer_Device_Interface';
import { Kartable_Device_Point_Interface } from 'src/app/Interface/Kartable_Device_Point_Interface';
import { Kartable_Order_Interface } from 'src/app/Interface/Kartable_Order_Interface';
import { Kartable_Station_Interface } from 'src/app/Interface/Kartable_Station_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KartableService {

  constructor(private http: HttpClient) { }


  GetOrder(Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetOrder?token=" + Token).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetOrderCount(Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetOrderCount?token=" + Token).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetStation(Token: String): Observable<Array<Kartable_Station_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetStation?token=" + Token).pipe(
      map(data => {
        return data as Array<Kartable_Station_Interface>
      })
    )
  }

  GetCalibrationInLocation(Token: String, id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetCalibrationInLocation?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetController(PeriodDate: number,
    StartSearchDate: String,
    EndSearchDate: String,
    Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetController?token=" + Token
      + "&PeriodDate=" + PeriodDate
      + "&StartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetCertificate(Customer: String,
    Expert_Name: String,
    RecieveCode: String,
    LetterCode: String,
    Devicename: String,
    PeriodDate: number,
    StartSearchDate: String,
    EndSearchDate: String,
    Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetCertificate?token=" + Token
      + "&Expert_Name=" + Expert_Name
      + "&RecieveCode=" + RecieveCode
      + "&LetterCode=" + LetterCode
      + "&CustomerName=" + Customer
      + "&PeriodDate=" + PeriodDate
      + "&StartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate
      + "&Devicename=" + Devicename).pipe(
        map(data => {
          return data as any
        })
      )
  }

  SubmitController(id: number,
    status: number,
    Token: String,
    customer: String,
    dsc: String): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Kartable/SubmitController?id=" + id
      + "&status=" + status
      + "&dsc=" + dsc
      + "&customer=" + customer
      + "&token=" + Token).pipe(
        map(data => {
          return data as any
        })
      )

  }

  SetCalibrationDetailVisible(id: number, Token: String): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Kartable/SetCalibrationDetailVisible?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as any
      })
    )

  }

  GetContollerReview(Token: String,
    StartSearchDate: String,
    EndSearchDate: String,
    username: String): Observable<Array<Kartable_Controller_Review_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetContollerReview?token=" + Token
      + "&username=" + username
      + "&startdate=" + StartSearchDate
      + "&enddate=" + EndSearchDate).pipe(
        map(data => {
          return data as Array<Kartable_Controller_Review_Interface>
        })
      )
  }

  GetDevicePoint(Token: String,
    StartSearchDate: String,
    EndSearchDate: String,
    username: String): Observable<Array<Kartable_Device_Point_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetDevicePoint?token=" + Token
      + "&username=" + username
      + "&startdate=" + StartSearchDate
      + "&enddate=" + EndSearchDate).pipe(
        map(data => {
          return data as Array<Kartable_Device_Point_Interface>
        })
      )
  }

  GetDevicePoint2(Token: String,
    StartSearchDate: String,
    EndSearchDate: String,
    deviceName: String,
    customerName: String,
    period: number,
    accept: number,
    LocationOfCalibration: number,
    expert: String): Observable<Array<Kartable_Device_Point_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetDevicePoint2?token=" + Token
      + "&period=" + period
      + "&accept=" + accept
      + "&customerName=" + customerName
      + "&deviceName=" + deviceName
      + "&CalibrationExpert=" + expert
      + "&LocationOfCalibration=" + LocationOfCalibration
      + "&startdate=" + StartSearchDate
      + "&enddate=" + EndSearchDate).pipe(
        map(data => {
          return data as Array<Kartable_Device_Point_Interface>
        })
      )
  }



  SubmitCertificate(Token: String, id: number, dsc: string): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Kartable/SubmitCertificate?token=" + Token
      + "&id=" + id
      + "&dsc=" + dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }


  GetCustomerDeviceReview(
    Token: String,
    StartSearchDate: String,
    EndSearchDate: String,
    Customer: String): Observable<Array<Kartable_Customer_Device_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Kartable/GetCustomerDeviceReview?token=" + Token
      + "&customerName=" + Customer

      + "&startdate=" + StartSearchDate
      + "&enddate=" + EndSearchDate).pipe(
        map(data => {
          return data as Array<Kartable_Customer_Device_Interface>
        })
      )
  }



  GetBarchasb(Token: String,letter_id:Number,customename:string): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetBarchasb?token=" + Token
      +"&letter_id=" + letter_id+"&customename=" + customename).pipe(
      map(data => {
        return data as Array<any>
      })
    )
  }


  ConfirmBarchasb(
    id: Array<number>,
    Token: String
  ): Observable<any> {

    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id: id,
      Token: Token,
    }

    return this.http.post(environment.BaseUrl + "Daro/Kartable/ConfirmBarchasb", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

}
